/**
 * locationPoints — 입지 4카드 파서 (대표 결정 2026-09-21 #3).
 *
 * 소스: Property.detailed_description 의 줄 단위 표식.
 *   [교통] 달구벌대로 직결 · KTX 서대구역 차량 10분
 *   [학군] 덕인초 도보 통학
 *   [생활] 이마트·하나로마트 인접
 *   [호재] 대구시청 신청사 이전 확정
 * 허용 키워드 4종 외는 무시. 매칭 0건이면 [] (섹션 미렌더).
 * 같은 키워드가 여러 줄이면 ' · ' 로 합친다.
 * 본문 표시용으로는 stripLocationPoints 로 표식 줄을 제거한다(중복 노출 방지).
 */

export type LocationKey = '교통' | '학군' | '생활' | '호재';
export const LOCATION_KEYS: LocationKey[] = ['교통', '학군', '생활', '호재'];

export interface LocationPoint {
  key: LocationKey;
  text: string;
}

const LINE_RE = /^\s*\[(교통|학군|생활|호재)\]\s*(.+?)\s*$/;
const TAG_SEG_RE = /\[(?:교통|학군|생활|호재)\][^<\n]*/g;

function decodeEntities(s: string): string {
  return s
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}

/** HTML/텍스트 → 줄 배열 (블록 태그·br 을 줄바꿈으로). */
export function toPlainLines(src: string): string[] {
  const text = src
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6])>/gi, '\n')
    .replace(/<[^>]+>/g, '');
  return decodeEntities(text)
    .split(/\n/)
    .map((l) => l.trim())
    .filter(Boolean);
}

export function parseLocationPoints(src?: string | null): LocationPoint[] {
  if (!src) return [];
  const byKey = new Map<LocationKey, string[]>();
  for (const line of toPlainLines(src)) {
    const m = line.match(LINE_RE);
    if (!m) continue;
    const key = m[1] as LocationKey;
    const text = m[2].trim();
    if (!text) continue;
    byKey.set(key, [...(byKey.get(key) ?? []), text]);
  }
  return LOCATION_KEYS.filter((k) => byKey.has(k)).map((k) => ({
    key: k,
    text: (byKey.get(k) as string[]).join(' · '),
  }));
}

/** 본문에서 [교통]/[학군]/[생활]/[호재] 표식 줄을 제거한다. 빈 문단도 정리. */
export function stripLocationPoints(html: string): string {
  if (!html) return html;
  return html
    .replace(TAG_SEG_RE, '')
    .replace(/<p>\s*(<br\s*\/?>\s*)*<\/p>/gi, '')
    .replace(/(<br\s*\/?>\s*){3,}/gi, '<br /><br />')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
